/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {NavController, AlertController, ViewController, NavParams, LoadingController, Loading} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import { BetDetailsTracePage } from "../betDetailsTrace/betDetailsTrace";

@Component({
    templateUrl: 'traceList.html',
    selector: 'trace-list-page',
})
export class TraceListPage {
    private recordList: any = [];
    private infiniteScrollBoolean: boolean = true;
    private totalNum: number = 0;
    requestData: any;
    betModes: any = {
        1: {
            modeid: 1,
            name: "元",
            rate: 1
        },
        2: {
            modeid: 2,
            name: "角",
            rate: 0.1
        },
        3: {
            modeid: 3,
            name: "分",
            rate: 0.01
        },
        4: {
            modeid: 4,
            name: "厘",
            rate: 0.001
        }
    };

    constructor(private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController,
                private userService: UserService, public viewCtrl: ViewController, private loadingCtrl: LoadingController) {
        this.requestData = navParams.get("requestData");
        this.loadingData(navParams.get("data"));
    }

    goDetail(index: string) {
        this.nav.push(BetDetailsTracePage, {
            revoke: true,
            betId: index
        });
    }

    doRefresh(refresher) {
        this.getFirstData(refresher);
    }

    getFirstData(refresher: any = null) {
        let dataParams = this.requestData;
        this.userService.traceSearch(dataParams, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.loadingData(data);
                if (refresher) {
                    refresher.complete();
                    this.infiniteScrollBoolean = true;
                }
            }
        });
    }

    doInfinite(infiniteScroll) {
        let dataParams = this.requestData;
        infiniteScroll.enable(false);
        setTimeout(() => {
            this.userService.traceSearchNext(dataParams, this).then(data => {
                if (!data["msg"]) {
                    data["reslist"].map(item => {
                        item["modeName"] = this.betModes[item["betmodle"]].name;
                        item["bettime"] = item["bettime"].replace(/-/g,'/');
                        return item;
                    });
                    this.recordList = this.recordList.concat(data["reslist"]);
                    this.totalNum = data["totalrecord"];
                    infiniteScroll.complete();
                    infiniteScroll.enable(true);
                } else {
                    infiniteScroll.enable(true);
                    this.infiniteScrollBoolean = false;
                }
            });
        }, 500);
    }

    //更新加工数据
    loadingData(data: any) {
        this.recordList = data["reslist"];
        this.recordList.map(item => {
            item["modeName"] = this.betModes[item["betmodle"]].name;
            item["bettime"] = item["bettime"].replace(/-/g,'/');
            return item;
        });
        this.totalNum = data["totalrecord"];
    }
}



// WEBPACK FOOTER //
// ./src/pages/traceList/traceList.ts